function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

/**
 * Type Check functions module.
 * All functions have a negative counter function in the namespace **not**.
 * @module spaceavocado/type-check
 */

/**
 * Is String
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 */
function isString(value) {
  return typeof value === 'string' || value instanceof String;
}
/**
 * Is Empty
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 * @throws {module:type-check.TypeCheckError} Unexpected type
 */

function isEmpty(value) {
  // String
  if (isString(value)) {
    return value.trim().length == 0;
  } // Array


  if (isArray(value)) {
    return value.length == 0;
  } // Unexpected type


  throw new TypeCheckError("Not supported type of check of the given value.\n    Supported: String, Array");
}
/**
 * Is Number
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 */

function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
}
/**
 * Is Function
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 */

function isFunction(value) {
  return typeof value === 'function';
}
/**
 * Is Object
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 */

function isObject(value) {
  return isNullOrUndefined(value) == false && _typeof(value) === 'object' && value.constructor === Object;
}
/**
 * Is Error
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 */

function isError(value) {
  return value instanceof Error;
}
/**
 * Is Null or Undefined
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 */

function isNullOrUndefined(value) {
  return typeof value === 'undefined' || value === null;
}
/**
 * Is Array - ES5 Array check
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 */

function isArray(value) {
  return Array.isArray(value);
}
/**
 * Is Promise
 * Basic check based on assumed presence
 * of then function on the given object.
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 */

function isPromise(value) {
  return isNullOrUndefined(value) == false && isFunction(value.then);
}
/**
 * Is ES6 Symbol
 * @param {mixed} value tested value
 * @return {boolean} result of the test
 */

function isSymbol(value) {
  return _typeof(value) === 'symbol';
}
/**
 * Is Enum Key
 * @param {string} key enum key
 * @param {object} source enum source object
 * @return {boolean} result of the test
 */

function isEnumKey(key, source) {
  if (isObject(source) == false || isString(key) == false) {
    return false;
  }

  return source[key] !== undefined;
} // Exported tests

var TESTS = {
  isString: isString,
  isEmpty: isEmpty,
  isNumber: isNumber,
  isFunction: isFunction,
  isObject: isObject,
  isError: isError,
  isNullOrUndefined: isNullOrUndefined,
  isArray: isArray,
  isSymbol: isSymbol,
  isPromise: isPromise,
  isEnumKey: isEnumKey
}; // Exported NOT tests

var nots = {};

var _loop = function _loop() {
  var key = _Object$keys[_i];

  nots[key] = function (value) {
    return !TESTS[key](value);
  };
};

for (var _i = 0, _Object$keys = Object.keys(TESTS); _i < _Object$keys.length; _i++) {
  _loop();
}

nots.isEnumKey = function (key, source) {
  return !isEnumKey(key, source);
};
/**
 * Default export - type check functions and its
 * negative counter functions in **not** property
 * @type {object}
 */


var index = Object.assign({
  not: nots
}, TESTS);
/**
 * Type Check Error
 * @external Error
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error}
 */

var TypeCheckError =
/*#__PURE__*/
function (_Error) {
  _inherits(TypeCheckError, _Error);

  /**
   * @constructor
   * @param {string} message Error message
   */
  function TypeCheckError(message) {
    var _this;

    _classCallCheck(this, TypeCheckError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TypeCheckError).call(this, message));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), TypeCheckError);
    }

    _this.constructor = TypeCheckError;
    _this.__proto__ = TypeCheckError.prototype;
    _this.message = message;
    _this.name = _this.constructor.name;
    return _this;
  }

  return TypeCheckError;
}(_wrapNativeSuper(Error));

export default index;
export { TypeCheckError, isArray, isEmpty, isEnumKey, isError, isFunction, isNullOrUndefined, isNumber, isObject, isPromise, isString, isSymbol };
